<template>
    <div>
        <!--支付宝  可以用window.client判断-->
        <!--<van-cell-group title="贷款账号" v-if="dataList.length>0">
            <van-cell v-for="(item, index) in dataList"
                :key="index"
                :title="item[0].info"
                is-link
                @click="routingTo(item[0].info)"
            />
        </van-cell-group>-->
        <!--百通-->
        <van-cell-group title="贷款账号" v-if="dataList.length>0">
            <van-cell v-for="(item, index) in dataList"
                      :key="index"
                      :title="item.jkhtbh"
                      is-link
                      @click="routingTo(item.jkhtbh)"
            />
        </van-cell-group>
    </div>
</template>

<script>
    import {Cell, CellGroup} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';

    export default {
        name: 'loanAccountNumberQuery',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell,
        },
        mounted(){

        },
        data(){
            return {
                target: '', //路由要跳转的地址
                dataList: [],
                url: '',
	            zjly: '',
            }
        },
        created(){
            this.target = this.$route.query.link;
            //console.log(this.target);
            //console.log(!!lightAppJssdk);
            //this.url = !!lightAppJssdk ? '/miapp/A5103/mpaasgateway' : '/miapp/A2009/mpaasgateway';
            this.url = '/miapp/A2009/mpaasgatewayunencrypted';
			// 2023年10月13日15:23:09
	        if(this.$route.query.hasOwnProperty('zjly')) this.zjly = this.$route.query.zjly;
            //console.log(this.url );
            this.getData();
        },
        methods: {
            getData(){
                let self = this,
                    url = this.url;
                console.log(url );
                self.$http.post(url , {
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    ybmapMessage: {
                        zjhm: self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.zjhm
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        if(res.result.length > 0){
                            self.dataList = res.result;
                        } else {
                            self.$utils.alert('未查询到贷款账户号');
                        }
                    } else {
                        self.$utils.alert(res.msg, function(){
                            self.$router.go(-1);
                        });
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            routingTo(jkhtbh){
                let self = this;
                self.$router.push({
                    path: '/' + self.target,
                    query: {
                        'openweb': 'paschybrid',
                        'account': jkhtbh,
	                    zjly: self.zjly,
                    }
                });
            }
        }

    }
</script>

<style lang="stylus">
    .van-cell-group__title
        color #518ede
        font-weight 400
</style>
<style lang="stylus" scoped>
    .top-info
        background #518ede
        .account-balance
            padding-top .6rem
            padding-bottom .6rem
            text-align center
            p
                font-size .3rem
                color rgba(255, 255, 255, .7)
            span
                display block
                font-size .6rem
                padding-top .18rem
                font-weight bold
                color #fff
        .account-top-info
            display flex
            justify-content space-between
            align-items center
            li
                text-align center
                width 50%
                padding-bottom .3rem
                margin-top .22rem
                p
                    font-size .3rem
                    color #fff
                span
                    font-size .3rem
                    display block
                    padding-top .14rem
                    color rgba(255, 255, 255, .7)


    .van-cell:not(:last-child)::after
        left 0
</style>